module.exports = __webpack_public_path__ + "static/img/video-culture_2x.4d36d3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/signLanguage/video-culture_2x.png
// module id = sqIV
// module chunks = 1